import { PermissionCode } from "@/constants/permissions";
import { AppRoutes } from "@/constants/routes";
import { Permiso } from "@/pages/role-asignation/schema/role-assignation.schema";
import { Flex, Link } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

interface Props {
  permissions: Permiso[];
}

export const RSATyGProdView = ({ permissions }: Props) => {
  const navigate = useNavigate();

  const hasAccess = (codigo: string) =>
    permissions?.some((p) => p.codigo === codigo && p.tipoPermiso === "R");

  const canUseSamplingRequests = hasAccess(PermissionCode.SAMPLING_REQUESTS);
  const canUseFlightRequests = hasAccess(PermissionCode.FLIGHT_REQUESTS);

  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">
      {canUseSamplingRequests && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.SAMPLING_REQUESTS)}>
          Muestreo
        </Link>
      )}
      {canUseFlightRequests && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.FLIGHT_REQUESTS)}>
          Vuelo
        </Link>
      )}
    </Flex>
  );
};
